import React, { useContext, useEffect, useState } from 'react';
import GeneralInfo from './GeneralInfo/GeneralInfo';
import Styles from './ArccosTile.module.scss';
import ArccosLogo from '../../assets/images/arccos-caddie-stacked.svg';
import { LocalizationContext } from '../../context/localizationContext';
import { insightsContext } from '../../context/insightsContext';
import APIClient from '../../helpers/APIClient';
import InsightMenu from '../InsightMenu/InsightMenu';
import PlayerInsightLoadingSpinner from './Loading/PlayerInsightLoadingSpinner/PlayerInsightLoadingSpinner';
import ServiceDown from './ServiceDown/ServiceDown';

const ArccosTile = (props) => {
  const { isTileView, toggleModal } = props;
  const localization = useContext(LocalizationContext);
  const { tileText } = localization;
  const insights = useContext(insightsContext);
  const { state, dispatch } = insights;
  const { data } = state;
  const { verified } = state;
  const [loading, setLoading] = useState(false);
  const [tileComponent, setTileComponent] = useState(null);

  const loadingSpinner = () => {
    return (
      <span className={Styles.loadingContainer}>
        <PlayerInsightLoadingSpinner color={'light'} />
      </span>
    );
  };

  const showInsightMenu = () => {
    setTileComponent(
      <InsightMenu
        isTileView={isTileView}
        toggleModal={toggleModal}
        tileText={tileText}
      />,
    );
  };

  useEffect(() => {
    APIClient.validateUser((response) => {
      if (
        response.status === 200
        && response?.data?.email_verified
      ) {
        dispatch({
          type: 'SET_ARCCOS_VERIFIED',
          verified: response?.data?.verified ?? false,
          acceptedTerms: response?.data?.accepted_terms === 1,
        });
      } else if (response.status !== 404 && response.status !== 200) {
        setTileComponent(
          <ServiceDown text={tileText.serviceDown} />,
        );
      } else {
        setTileComponent(
          <GeneralInfo
            setTileComponent={setTileComponent}
            setLoading={setLoading}
          />,
        );
      }
    });
  }, []);

  useEffect(() => {
    if (verified) {
      setTileComponent(loadingSpinner());
      APIClient.getInsights((status, response) => {
        if (status === 200) {
          APIClient.getUserProfile((resp) => {
            const profile = resp.status === 200 ? resp.data : null;
            dispatch({
              type: 'ADD_INSIGHTS',
              data: response.data,
              profile,
            });
          });
        } else {
          dispatch({
            type: 'SET_DATA_ERROR',
          });
          showInsightMenu();
        }
        setLoading(false);
      });
    }
  }, [verified]);

  useEffect(() => {
    if (data) {
      showInsightMenu();
    }
  }, [data]);

  return (
    <div className={Styles.arccosTileContainer}>
      <div className={Styles.tileHeader}>
        <div className={Styles.headerText}>
          <div>
            <div>{tileText.headers.myInsights}</div>
            <div className={Styles.smallHeaderText}>
              {tileText.headers.headerSlogan}
            </div>
          </div>
          <div>
            <img src={ArccosLogo} alt='logo' />
          </div>
        </div>
      </div>
      <div className={Styles.arccosTile}>
        {tileComponent}
      </div>
    </div>
  );
};

export default ArccosTile;
